import Experience from "../Experience";
import * as THREE from "three"



export default class CandyCane
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.countCandyCane = 10

        //Setup
        this.resource = this.resources.items.candyCane 
        this.setModel()
    }
    
    setModel()
    {
        this.model = this.resource.scene.clone()
        this.model2 = this.resource.scene.clone()
        this.model3 = this.resource.scene.clone()
        this.model4 = this.resource.scene.clone()




        this.model.scale.setScalar(0.03)
        this.model.position.set(12, - 0.1, 6)
        this.model.rotation.y = Math.PI

        this.model.traverse((child) =>
        {
            if(child instanceof THREE.Mesh)
            {
                child.receiveShadow = true
                child.castShadow = true

            }
        })

        this.model2.scale.setScalar(0.03)
        this.model2.position.set(13, - 0.2, -5)
        this.model2.rotation.y = Math.PI * 0.2

        this.model2.traverse((child) =>
        {
            if(child instanceof THREE.Mesh)
            {
                child.receiveShadow = true
                child.castShadow = true

            }
        })

        this.model3.scale.setScalar(0.03)
        this.model3.position.set(1, - 0.1, 2)
        this.model3.rotation.y = Math.PI * 0.7
        this.model3.castShadow = true

        this.model3.traverse((child) =>
        {
            if(child instanceof THREE.Mesh)
            {
                child.receiveShadow = true
                child.castShadow = true

            }
        })

        
        this.model4.scale.setScalar(0.03)
        this.model4.position.set(-2, - 0.1, -2)
        this.model4.rotation.y = Math.PI * 1.4
        this.model4.castShadow = true

        this.model4.traverse((child) =>
        {
            if(child instanceof THREE.Mesh)
            {
                child.receiveShadow = true
                child.castShadow = true

            }
        })
    
        this.scene.add(this.model)
        this.scene.add(this.model2)
        this.scene.add(this.model3)
        this.scene.add(this.model4)

    }
}